import * as React from 'react'
import { useActions } from './useActions'
import TablePagination from '@mui/material/TablePagination'

type Props = {
  disableInteraction: boolean
}

export function GridPagination(props: Props) {
  const { disableInteraction } = props

  const { disableNextButton, disablePrevButton, ...tableProps } =
    useActions(disableInteraction)

  return (
    <TablePagination
      component="div"
      {...tableProps}
      SelectProps={{ disabled: disableInteraction }}
      nextIconButtonProps={{ disabled: disableNextButton }}
      backIconButtonProps={{ disabled: disablePrevButton }}
    />
  )
}
